/// <reference path="../../../app.definition.ts" />

import angular from 'angular';
import { Util } from '@common/util';
export class FieldConfigurationsPopupController {
  static $inject = ["$uibModalInstance", "NgTableParams", "PopUpService", "ApiAdapterService", "fieldConfigurationsData", "dataModel", "assignmentId"];
  constructor($uibModalInstance, NgTableParams, PopUpService, ApiAdapterService, fieldConfigurationsData, dataModel, assignmentId) {
    var fieldConfigurationsPopupVm: any = this;

    fieldConfigurationsPopupVm.fieldConfigurationsData = fieldConfigurationsData;
    fieldConfigurationsPopupVm.dataModel = dataModel;
    fieldConfigurationsPopupVm.assignmentId = assignmentId;
    fieldConfigurationsPopupVm.dtdTrialsOptions = [];
    fieldConfigurationsPopupVm.rowCountHelp = Util.ROW_COUNT_HELP;
    fieldConfigurationsPopupVm.dtdValues = Util.DTD_VALUES;
    fieldConfigurationsPopupVm.deleteFilledRows = false;

    for (let config of fieldConfigurationsPopupVm.fieldConfigurationsData) {
      if (config.option == "Trial Count") {
        fieldConfigurationsPopupVm.dtdTrials = parseInt(config.field.fieldOptions.defaultRows);
        fieldConfigurationsPopupVm.defaultRows = parseInt(config.field.fieldOptions.defaultRows);
        let n = config.values.min;
        var supportedMaxValue, max; //dummy value
        let countersArr = JSON.parse(config.field.fieldOptions.data);
        // it is finalized that whatever the configuration is there in max trials the number of trials should not be more than 20
        if (Array.isArray(countersArr) && countersArr.length > 0) {
          supportedMaxValue = countersArr.length;
          max = (config.values.max > supportedMaxValue) ? supportedMaxValue : config.values.max;
        } else {
          max = config.values.max;
        }
        let multiple = !!config.values.multipleOf ? config.values.multipleOf : 1;

        while (n <= max) {
          fieldConfigurationsPopupVm.dtdTrialsOptions.push(n);
          n += multiple;
        }
      }
    }

    fieldConfigurationsPopupVm.getTableConfiguration = (data: any, sortingParam: any, count: number) => {
      var tableParams = {
        sorting: sortingParam,
        count: count
      };
      var tableSettings = {
        counts: [],
        paginationMaxBlocks: 3,
        paginationMinBlocks: 2,
        dataset: data
      };
      return new NgTableParams(tableParams, tableSettings);
    }

    fieldConfigurationsPopupVm.fieldConfigTableParams = fieldConfigurationsPopupVm.getTableConfiguration(fieldConfigurationsPopupVm.fieldConfigurationsData, {
      option: 'asc'
    }, 3);

    fieldConfigurationsPopupVm.formatTrialDataSequence = (trialData, maxRows) => {
      let dataCursor = 0;
      while (dataCursor < trialData.length) {
        dataCursor++;
        if (trialData[dataCursor - 1].id == dataCursor) {

        } else {
          trialData[dataCursor - 1].id = dataCursor;
          trialData[dataCursor - 1].trial = dataCursor.toString();
        }
      }

      let rowsToAdd = maxRows - dataCursor;
      while (rowsToAdd > 0) {
        let blankRow = angular.copy(trialData[trialData.length - 1]);
        blankRow.resultType = null;
        blankRow.counterArray.note = "";
        blankRow.counterArray.counter.physical.val = 0;
        blankRow.counterArray.counter.gestural.val = 0;
        blankRow.counterArray.counter.tactile.val = 0;
        blankRow.counterArray.counter.verbal.val = 0;
        blankRow.counterArray.counter.visual.val = 0;
        blankRow.id = blankRow.id + 1;
        blankRow.trial = blankRow.id.toString();
        trialData.push(blankRow);
        rowsToAdd--;
      }
      return trialData;
    }

    fieldConfigurationsPopupVm.checkIfFilledRowsToBeDeleted = (check: boolean) => {
      let fieldConfigData;
      if (check) {
        fieldConfigData = angular.copy(fieldConfigurationsPopupVm.fieldConfigurationsData);
      } else {
        fieldConfigData = fieldConfigurationsPopupVm.fieldConfigurationsData
      }
      for (let config of fieldConfigData) {
        if (config.option == "Trial Count") {
          let trialDataJson = JSON.parse(config.field.fieldOptions.data);
          let fieldId = config.field.id;
          let trialData;
          if (check) {
            trialData = angular.copy(fieldConfigurationsPopupVm.dataModel["field" + fieldId]);
          } else {
            trialData = fieldConfigurationsPopupVm.dataModel["field" + fieldId];
          }

          if (!!fieldConfigurationsPopupVm.dtdTrials) {
            if (!!config) {
              if (fieldConfigurationsPopupVm.dtdTrials < parseInt(config.field.fieldOptions.defaultRows)) {
                let countToRemove = parseInt(config.field.fieldOptions.defaultRows) - fieldConfigurationsPopupVm.dtdTrials;
                let countRemoved = 0;
                for (var i = parseInt(config.field.fieldOptions.defaultRows); i--;) {
                  if ((!trialData[i].resultType && (trialData[i].counterArray.counter.physical.val == 0
                    && trialData[i].counterArray.counter.gestural.val == 0 && trialData[i].counterArray.counter.tactile.val == 0 && trialData[i].counterArray.counter.verbal.val == 0 && trialData[i].counterArray.counter.visual.val == 0) && trialData[i].counterArray.note == "")
                    && countToRemove > 0) {
                    trialData.splice(i, 1);
                    countToRemove--;
                    countRemoved++;
                  }
                }
                if (countToRemove > 0) {
                  fieldConfigurationsPopupVm.deleteFilledRows = true;
                  return { "countToRemove": countToRemove, "countRemoved": countRemoved };
                }

              }
            }
          }
        }
      }
    }

    fieldConfigurationsPopupVm.updateTrials = () => {
      for (let config of fieldConfigurationsPopupVm.fieldConfigurationsData) {
        if (config.option == "Trial Count") {
          let trialDataJson = JSON.parse(config.field.fieldOptions.data);
          let fieldId = config.field.id;

          if (!!fieldConfigurationsPopupVm.dtdTrials) {
            if (!!config) {
              if (fieldConfigurationsPopupVm.dtdTrials < parseInt(config.values.min) || fieldConfigurationsPopupVm.dtdTrials > parseInt(config.values.max)) {
                PopUpService.openInformationModal("Invalid Number");
              } else {
                if (fieldConfigurationsPopupVm.dtdTrials < parseInt(config.field.fieldOptions.defaultRows)) {
                  let countDetail = fieldConfigurationsPopupVm.checkIfFilledRowsToBeDeleted(false);
                  let trialData = angular.copy(fieldConfigurationsPopupVm.dataModel["field" + fieldId]);
                  if (fieldConfigurationsPopupVm.deleteFilledRows) {
                    trialData.splice(config.field.fieldOptions.defaultRows - countDetail.countToRemove - countDetail.countRemoved, countDetail.countToRemove);
                    fieldConfigurationsPopupVm.dataModel["field" + fieldId] = fieldConfigurationsPopupVm.formatTrialDataSequence(trialData, parseInt(config.values.max));
                    config.field.fieldOptions.defaultRows = fieldConfigurationsPopupVm.dtdTrials;
                    //fieldConfigurationsPopupVm.updateTrialsCall();
                    $uibModalInstance.close({
                      "dataModel": fieldConfigurationsPopupVm.dataModel,
                      "config": config,
                      "assignmentId": fieldConfigurationsPopupVm.assignmentId,
                      "trialCount": fieldConfigurationsPopupVm.dtdTrials
                    });
                  } else {
                    fieldConfigurationsPopupVm.dataModel["field" + fieldId] = fieldConfigurationsPopupVm.formatTrialDataSequence(trialData, parseInt(config.values.max));
                    config.field.fieldOptions.defaultRows = fieldConfigurationsPopupVm.dtdTrials;
                    //fieldConfigurationsPopupVm.updateTrialsCall();
                    $uibModalInstance.close({
                      "dataModel": fieldConfigurationsPopupVm.dataModel,
                      "config": config,
                      "assignmentId": fieldConfigurationsPopupVm.assignmentId,
                      "trialCount": fieldConfigurationsPopupVm.dtdTrials
                    });
                  }

                } else if (fieldConfigurationsPopupVm.dtdTrials > parseInt(config.field.fieldOptions.defaultRows)) {
                  config.field.fieldOptions.defaultRows = fieldConfigurationsPopupVm.dtdTrials;
                  //fieldConfigurationsPopupVm.updateTrialsCall();
                  $uibModalInstance.close({
                    "dataModel": fieldConfigurationsPopupVm.dataModel,
                    "config": config,
                    "assignmentId": fieldConfigurationsPopupVm.assignmentId,
                    "trialCount": fieldConfigurationsPopupVm.dtdTrials

                  });

                }


              }
            }
          }
        }
      }
    }

    fieldConfigurationsPopupVm.updateTrialsCall = () => {
      ApiAdapterService.updateTrialCount({ "assignmentId": fieldConfigurationsPopupVm.assignmentId, "fieldId": config.field.id, "trialCount": fieldConfigurationsPopupVm.dtdTrials }).then((s) => {
      },
        (e) => {
          PopUpService.openInformationModal(e);
        });
    }
    fieldConfigurationsPopupVm.dismiss = () => {
      $uibModalInstance.dismiss();
    }

  }

}
angular.module('eCareVault.common.popUp')
  .controller('FieldConfigurationsPopupController', FieldConfigurationsPopupController);
